export enum SurveyPropertyUnderValidation {
	audienceSource = 'AudienceSource',
	audienceSourceType = 'AudienceSourceType',
	name = 'Name',
	questions = 'Questions',
	pageFlowElements = 'PageFlowElements',
	displayLogic = 'DisplayLogic',
	demographicQuestions = 'DemographicQuestions',
	externalApplicationType = 'ExternalApplicationType',
	surveyTypes = 'SurveyTypes',
}
